var _circle, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloverLogoPurpleCircle({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 48,
    cy: 48,
    r: 48,
    fill: "#442255"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1501_23173)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.6502 36.1816C46.6502 30.8778 42.3455 26.5713 37.0379 26.5713C31.7315 26.5713 27.4297 30.8723 27.4297 36.1761C27.4297 41.4798 31.7314 45.7918 37.0403 45.7918H46.6502L46.6502 36.1816Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.3521 36.1816C49.3521 30.8778 53.6568 26.5713 58.9644 26.5713C64.2708 26.5713 68.5726 30.8723 68.5726 36.1761C68.5726 41.4798 64.2708 45.7918 58.962 45.7918H49.3521L49.3521 36.1816Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.3521 58.1039C49.3521 63.4129 53.6556 67.7142 58.9653 67.7142C64.2691 67.7142 68.5726 63.4161 68.5726 58.1071C68.5726 52.8032 64.2691 48.4937 58.9619 48.4937L49.3521 48.4937V58.1039Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.6502 58.1039C46.6502 63.4129 42.3467 67.7142 37.0371 67.7142C31.7332 67.7142 27.4297 63.4161 27.4297 58.1071C27.4297 52.8032 31.7331 48.4937 37.0403 48.4937H46.6502V58.1039ZM37.0371 65.0042C40.8512 65.0042 43.9543 61.9102 43.9543 58.1071V51.1911H37.0458C33.2299 51.1911 30.1253 54.3056 30.1253 58.1071C30.1253 61.9102 33.2258 65.0042 37.0371 65.0042Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1501_23173"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 41.1429,
    height: 41.1429,
    fill: "white",
    transform: "translate(27.4297 26.5713)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloverLogoPurpleCircle);
export default __webpack_public_path__ + "assets/media/clover-logo-purple-circle.20ad47ee4ddf0cb547c98e9b508ae62e.svg";
export { ForwardRef as ReactComponent };